module.exports = __webpack_public_path__ + "static/img/ent-detail-55.f6e6331.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-55.jpg
// module id = 5QzH
// module chunks = 52